module.exports = __webpack_public_path__ + "img/business@2x.fdb58003.jpg";